<template>
    <div class="warp">
        <div class="selectList">
            <div :class="everyIdx == index ? 'every selected':'every' " v-for="(item,index) in  selectList" :key="item[keyk]" @click="change(item,index)">
                {{item[keyval]}}
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    props:{
        selectList:Array,
        keyk:String,
        keyval:String
    },
    data(){
        return{
            everyIdx:0
        }
    },
    methods:{
        change(site,idx){
            // this.everyIdx = idx
            this.$emit('tabTitle',site)
        }
    },
    mounted(){
        // console.log(this.selectList);
    }
}
</script>

<style lang="less" scoped>
.warp{
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #030D18 0%, #162C5D 100%);
    box-shadow: 0 0 16rem 2rem rgba(13, 148, 255, 0.5);
    .selectList{
        padding-top: 4rem;
        width: 98.5%;
        height: 100%;
        overflow-x: hidden;
        overflow-y:scroll ;
        .every{
            width: 100%;
            height: 3.33vh;
            line-height: 3.33vh;
            color: #E6F3FD;
            font-size: 16rem;
            padding-left: 19rem;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover{
                background: linear-gradient(90deg, rgba(13, 148, 255, 0.5) 0%, rgba(13, 148, 255, 0) 100%);
            }
        }
        .selected{
            background: none;
        }
    }
    
    .selectList::-webkit-scrollbar{
        width: 6rem;
    }
    .selectList::-webkit-scrollbar-thumb{
        border-radius:3rem ;
        background-color: #fff;
        height: 2px;
    }
    // .selectList::-webkit-scrollbar-track {
    //     background-color: rgba(255, 255, 255, 0.2);
    //     border-radius:3rem ;
    // }
}
</style>